import { render, staticRenderFns } from "./DocumentCountOptionsPanel.vue?vue&type=template&id=99b42a0c&scoped=true&"
import script from "./DocumentCountOptionsPanel.vue?vue&type=script&lang=js&"
export * from "./DocumentCountOptionsPanel.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCountOptionsPanel.vue?vue&type=style&index=0&id=99b42a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b42a0c",
  null
  
)

export default component.exports